import { CookieService } from 'ngx-cookie-service';
import { RechargeSansInscriptionService } from './../api/recharge-sans-inscription.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-recharge-sans-inscription',
  templateUrl: './recharge-sans-inscription.component.html',
  styleUrls: ['./recharge-sans-inscription.component.scss']
})
export class RechargeSansInscriptionComponent implements OnInit {


  guid_id_pl: string;
  guid: string;
  id_pl: number;
  stationDetail: any;

  hide = true;
  formGroup: FormGroup;
  submitted = false;
  IsWait: boolean = true;



  constructor(private cookieService: CookieService, private router: Router, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer, private rechargeSansInscriptionService: RechargeSansInscriptionService) {
    this.activatedRoute.params.subscribe(params => {
      this.guid_id_pl = `${params.guid}/${params.idpl}`
      this.id_pl = params.idpl
      this.guid = params.guid
      console.log(params)
    })
  }
  ngOnInit(): void {
    this.subscribeToRecharge(this.guid_id_pl);
    this.createForm();
  }



  // reactive form
  createForm() {

    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let pinregex: RegExp = /^[0-9]+$/;
    let phonenumberregex: RegExp = /^(0|\+33|\+41|\+590|\+32|\+262|\+247|\+34|\+31|\+352|\+351|\+86|\+1)[1-9]([-.: ]?[0-9]{2}){4}$/;



    this.formGroup = this.formBuilder.group({

      pin: [null, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(pinregex)]],
      email: [null, [Validators.pattern(emailregex)]],
      phonenumber: [null, [Validators.pattern(phonenumberregex)]],


    }
    );
  }






  getErrorPhonenumber() {
    if (this.formGroup.get('phonenumber').hasError('required')) { return 'Numéro de téléphone requis' }
    if (this.formGroup.get('phonenumber').hasError('pattern')) { return 'Numéro de téléphone non valide' }
  }

  getErrorEmail() {
    if (this.formGroup.get('email').hasError('pattern')) { return 'Adresse E-mail non valide' }
  }

  getErrorPassword() {
        return this.formGroup.get('pin').hasError('required') ? 'Le code PIN requis' :
      this.formGroup.get('pin').hasError('pattern') ?
        'Le code PIN est invalide' : 'Le code PIN doit comporter 4 chiffres';
  }



  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }





  subscribeToRecharge(guid) {
    this.rechargeSansInscriptionService.getStationRechargeSansInscription(guid).subscribe(
      data => {
        this.IsWait = false;
        console.log(data.data)

        this.stationDetail = data.data


        if (data.data.available === 0) {
          this.stationDetail.guid = this.guid
          this.stationDetail.id_pl = this.id_pl
          this.rechargeSansInscriptionService.changeRechargeInfo({ station: data.data, user: null });
          this.router.navigate([`/retour/recharge-sans-inscription`]);
        }

        
      },
      err => {
        console.log(err)
      });
  }




  //send user  with POST
  signUp() {


    if (this.formGroup.invalid) {
      return;
    }

    let userData = this.formGroup.value;

    console.log("formulaire")

    console.log(userData)

    if (userData.phonenumber.startsWith('0')) {
      userData.phonenumber = userData.phonenumber.replace('0', '+33')
    }

    userData.station_id = this.stationDetail.id;

    this.rechargeSansInscriptionService.postUserRecharge(userData).subscribe(
      data => {
        console.log(data)
        console.log(data.data)
        //this.openSnackBarDone('Compte créé avec succès')
        //if(data.)
        this.stationDetail.guid = this.guid
        this.stationDetail.id_pl = this.id_pl
        this.rechargeSansInscriptionService.changeRechargeInfo({ station: this.stationDetail, user: data.data});
        let info = { station: this.stationDetail, user: data.data}
        console.log("info")
        console.log(info)
        console.log("info")
        localStorage.setItem('recharge_info', JSON.stringify(info));
        let tokenString = JSON.parse(localStorage.getItem('recharge_info'))
        console.log("err")
        console.log(tokenString)
        this.router.navigate([`/payment`]);

      },
      err => {

        console.log(err)
        // this.openSnackBar(err.error.data.map(x => x.message))
      });

  }








}
